export default {"src":"/_next/static/media/eplorer.bcf807d3.svg","height":83,"width":83,"blurWidth":0,"blurHeight":0};